import TabToggle from 'components/commons/tab-toogle'
import { InlineError, Input } from 'avo-ui'

export const UsageLimit = ({ sectionRef, voucherDetail, onChangeUsageLimit, errorForm }) => {
    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'Usage Limit'}
                content={
                    <div className={'flex space-x-16'}>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Usage Limit Per Voucher</div>
                                <Input
                                    type={'number'}
                                    className={'flex-1'}
                                    name={'usage_limit'}
                                    placeholder={'Voucher dapat digunakan X kali'}
                                    value={voucherDetail?.usage_limit}
                                    onChange={(item) => onChangeUsageLimit({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.limit?.usage_limit} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Usage Limit to X item</div>
                                <Input
                                    type={'number'}
                                    className={'flex-1'}
                                    name={'usage_limit_to_x_item'}
                                    placeholder={'Voucher dapat digunakan untuk X item di dalam pembelanjaan'}
                                    value={voucherDetail?.usage_limit_to_x_item}
                                    onChange={(item) => onChangeUsageLimit({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.limit?.usage_limit_to_x_item} />
                            </div>
                        </div>
                        <div className={'flex-1'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Usage Limit Per User</div>
                                <Input
                                    type={'number'}
                                    className={'flex-1'}
                                    name={'usage_limit_per_user'}
                                    placeholder={'Voucher dapat digunakan X kali untuk 1 user'}
                                    value={voucherDetail?.usage_limit_per_user}
                                    onChange={(item) => onChangeUsageLimit({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.limit?.usage_limit_per_user} />
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    )
}
